export class ActivityModel {

    public wasJson: string;

    constructor(obj?: any) {
        this.wasJson = obj && obj.was        || '';
    }


}



// WEBPACK FOOTER //
// ./src/app/models/activity.model.ts